//设置cookie,增加到vue实例方便全局调用

export function setCookie(c_name, value, expiredays) {
    var exdate = new Date();
    // 按毫秒计算，支持小时级精度（如 2/24 表示 2 小时），修复原实现传字符串导致过期时间异常的问题
    exdate.setTime(exdate.getTime() + expiredays * 24 * 3600 * 1000);
    document.cookie = c_name + "=" + value + ((expiredays == null) ? "" : ";expires=" + exdate.toGMTString());
};

export function getCookie(name) {
    var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    if (arr = document.cookie.match(reg)) {
        return (arr[2]);
    } else {
        return false
    }
}


export function delCookie(name) {
    var exp = new Date();
    exp.setTime(exp.getTime() - 1);
    var cval = getCookie(name);
    if (cval) {
        document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
    }
};